<template>
  <div class="full">
    <div class="input-wrap" v-for="(input, index) in inputs" :key="index">
      <image-input v-model="input.value"  :label="input.label" :error="input.error" v-if="input.type === 'image'" :useParse="input.useParse" :disabled="input.disabled"></image-input>
      <file-input v-model="input.value"  :label="input.label" :error="input.error" v-else-if="input.type === 'file'" :useParse="input.useParse" :generateName="input.generateName" :disabled="input.disabled"></file-input>
      <admin-input v-model="input.value"  :label="input.label" :error="input.error" :role="input.role" v-else-if="input.type === 'admin'" :disabled="input.disabled"></admin-input>
      <json-input v-model="input.value"  :label="input.label" :error="input.error" v-else-if="input.type === 'json'" :disabled="disabled"></json-input>
      <m-switch v-model="input.value" :label="input.label" v-else-if="input.type === 'Boolean'"></m-switch>
      <v-select
        v-model="input.value"
        :items="input.items"
        :chips="input.multiple"
        :label="input.label"
        :multiple="input.multiple"
        v-else-if="input.type === 'select'"
      ></v-select>
      <v-combobox
        v-model="input.value"
        :label="input.label"
        multiple
        small-chips
        v-else-if="input.type === 'combobox'"
      ></v-combobox>
      <v-textarea :label="input.label"
                  v-model="input.value"
                  @input="clearError(input)"
                  :error-messages="input.error"
                  :disabled="input.disabled"
                  v-else-if="input.type === 'textarea'"></v-textarea>
      <v-text-field :label="input.label"
                    v-model.number="input.value"
                    @input="clearError(input)"
                    :error-messages="input.error"
                    type="number"
                    :disabled="input.disabled"
                    @keyup.enter="next(index)"
                    v-else-if="input.type === 'Number'"></v-text-field>
      <attachment v-model="input.value" v-else-if="input.type === 'attachment'" edit></attachment>
      <v-text-field :label="input.label"
                    v-model="input.value"
                    @input="clearError(input)"
                    :error-messages="input.error"
                    :type="input.type || 'text'"
                    :disabled="input.disabled"
                    :placeholder="input.placeholder"
                    @keyup.enter="next(index)"
                    v-else></v-text-field>
    </div>
  </div>
</template>
<script>
import ImageInput from './imageInput'
import AdminInput from './adminInput'
import FileInput from './fileInput'
import Attachment from './attachment'

export default {
  components: {
    FileInput,
    AdminInput,
    Attachment,
    ImageInput },
  data: function () {
    return {
      inputs: [],
      values: {}
    }
  },
  created () {
    this.init()
  },
  watch: {
    data () {
      this.init()
    }
  },
  methods: {
    next (index) {
      if (index === this.inputs.length - 1) {
        this.$emit('inputComplete')
      } else {
        let next = this.$el.children[index + 1].querySelector('input,textarea')
        if (next) next.focus()
      }
    },
    formatType (type) {
      if (!type) return 'text'
      type = type.toLowerCase()
      if (type === 'string') return 'text'
      return type
    },
    init () {
      this.inputs = this.data.filter(input => {
        return !input.hide
      })
    },
    setErrors (errors) {
      for (let input of this.inputs) {
        let error = errors.find((error) => {
          return error.field === input.name
        })
        if (error) {
          this.$set(input, 'error', error.message)
        } else {
          this.$delete(input, 'error')
        }
      }
      this.$forceUpdate()
    },
    clearError (input) {
      if (input) {
        this.$delete(input, 'error')
      } else {
        for (let input of this.inputs) {
          this.$delete(input, 'error')
        }
      }
    },
    getData () {
      let data = {}
      for (let input of this.inputs) {
        data[input.name] = input.value
      }
      return data
    },
    loadData (data, clear = true) {
      this.inputs.forEach(input => {
        if (data && typeof data[input.name] !== 'undefined') {
          this.$set(input, 'value', data[input.name])
        } else {
          if (clear) {
            delete input.value
          }
        }
      })
      this.$forceUpdate()
    }
  },
  props: {
    data: Array,
    disabled: Boolean
  }
}
</script>
<style lang="scss" scoped>

</style>
